import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=5c50ca24&"
import script from "./Transactions.vue?vue&type=script&lang=ts&"
export * from "./Transactions.vue?vue&type=script&lang=ts&"
import style0 from "./Transactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports